import script from "./FileManager.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileManager.vue?vue&type=script&lang=ts&setup=true"

import "./FileManager.vue?vue&type=style&index=0&id=72030ada&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72030ada"]])

export default __exports__